import axios from 'axios';
import {
	FETCH_BLOCKS,
	FETCH_BLOCK_CATS,
	FETCH_CORPORATE_EXERCISES,
	FETCH_EQUIPMENT,
	FETCH_EXERCISE_CATS,
	FETCH_STORE_PRODUCTS,
	FETCH_TRAINER_EXERCISES,
	SET_EXERCISES_LOAD_MORE,
	FETCH_WORKOUTS,
	RESET_WORKOUTS,
	RESET_WORKOUT_INFO,
	FETCH_WORKOUT_CATS,
	FETCH_WORKOUT_INFO,
	UPDATE_ORDER_WORKOUTS
} from '../actionTypes';
import { showAlert } from './alert';
import { addError } from './errors';
import { hideLoader, showLoader } from './loader';
import { checkState, paginationLimit } from './../../helpers'

const SERVICE = 'workouts';

function makeid(length) {
	var result = '';
	var characters = '0123456789';
	var charactersLength = characters.length;
	for (var i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
}

const _getIdFromTime = () => {
	return makeid(16);
};

function _postNewPlans(children, parentId, type) {
	let postArr = [],
		addPlanIndexIds = [],
		postPromises = [];

	const parentIdKey = type === 'workout' ? 'workoutId' : 'blockId';

	// Added children array with order id
	let updateChidrenWithOrder = children.map(function (item, index) {
		const updatedItem = item;
		delete updatedItem.childId;
		return {
			...updatedItem,
			orderId: index,
		};
	});

	// find all end circuits

	let filterEndCircuitFromChildren = updateChidrenWithOrder.filter(function (
		child
	) {
		return (
			child.content.includes('Circuit') &&
			child.content.includes('End') &&
			child.type === 'circuit'
		);
	});

	// find all plans between the circuits

	if (filterEndCircuitFromChildren.length > 0) {
		for (let index = 0; index < filterEndCircuitFromChildren.length; index++) {
			let circuitId = _getIdFromTime();
			const endCircuit = filterEndCircuitFromChildren[index];
			const endCircuitId = endCircuit.id;
			const endCircuitParentId = endCircuit.parent;
			let orderId = endCircuit.orderId;
			addPlanIndexIds.push(endCircuitId);
			if (endCircuitId) {
				postArr.push({
					requestType: 'sequences',
					sequenceId: _getIdFromTime(),
					parent: type === 'workout' ? '' : type,
					parentId: parentId,
					child: 'circuit',
					childId: `${circuitId}`,
					[parentIdKey]: parentId,
					orderId: orderId,
				});
			}

			const startCircutIndex = updateChidrenWithOrder.findIndex(function (
				child
			) {
				return child.id === endCircuitParentId;
			});

			const endCircutIndex = updateChidrenWithOrder.findIndex(function (child) {
				return child.id === endCircuitId;
			});

			const startCircuit = updateChidrenWithOrder[startCircutIndex];

			const circuitFormData = startCircuit.formData;

			addPlanIndexIds.push(startCircuit.id);

			let planIds = [];
			for (
				let planIndex = startCircutIndex + 1;
				planIndex < endCircutIndex;
				planIndex++
			) {
				let planSequneceId = _getIdFromTime();
				const planInCircuit = updateChidrenWithOrder[planIndex];
				console.log(planInCircuit);
				addPlanIndexIds.push(planInCircuit.id);
				planIds.push(planSequneceId);
				if (planInCircuit.formData && planInCircuit.formData.workoutId === -1) {
					delete planInCircuit.formData.workoutId;
				}
				postArr.push({
					requestType: 'plans',
					...planInCircuit.formData,
					[parentIdKey]: parentId,
					planId: planSequneceId,
					circuitId: circuitId,
				});
			}

			if (circuitFormData) {
				postArr.push({
					requestType: 'circuits',
					planIds: planIds.join(','),
					...circuitFormData,
					[parentIdKey]: parentId,
					circuitId: circuitId,
				});
			}
		}
	}

	// find all blocks

	let filterBlockFromChildren = updateChidrenWithOrder.filter(function (child) {
		return child.type === 'block';
	});

	if (filterBlockFromChildren.length > 0) {
		for (let index = 0; index < filterBlockFromChildren.length; index++) {
			const block = filterBlockFromChildren[index];
			addPlanIndexIds.push(block.id);
			let orderId = block.orderId;
			postArr.push({
				requestType: 'sequences',
				sequenceId: _getIdFromTime(),
				parent: type === 'workout' ? '' : type,
				parentId: parentId,
				child: 'block',
				childId: block.data._id,
				[parentIdKey]: parentId,
				orderId: orderId,
			});
		}
	}

	// find all other plans

	let filterOtherPlans = updateChidrenWithOrder.filter(function (child) {
		return addPlanIndexIds.indexOf(child.id) < 0;
	});

	for (let index = 0; index < filterOtherPlans.length; index++) {
		const otherPlan = filterOtherPlans[index];
		delete otherPlan.childId;
		let planId = _getIdFromTime();
		let orderId = otherPlan.orderId;
		postArr.push({
			requestType: 'sequences',
			sequenceId: _getIdFromTime(),
			parent: type === 'workout' ? '' : type,
			parentId: parentId,
			child: 'plan',
			childId: planId,
			orderId: orderId,
			[parentIdKey]: parentId,
		});
		if (otherPlan.formData && otherPlan.formData.workoutId === -1) {
			delete otherPlan.formData.workoutId;
		}
		postArr.push({
			requestType: 'plans',
			...otherPlan.formData,
			[parentIdKey]: parentId,
			planId: planId,
		});
	}
	// add promises
	if (postArr.length > 0) {
		for (let index = 0; index < postArr.length; index++) {
			const data = postArr[index];
			const requestType = data.requestType;
			delete data.requestType;
			postPromises.push(axios.post(requestType, data));
		}
	} else {
		postPromises = null;
	}

	return postPromises;
}

export const fetchInfo = workoutId => dispatch => {
	const filter = { workoutId: workoutId };
	const promises = [];
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	promises.push(axios.get('categories', { params: { type: 'workout' } }));
	promises.push(
		axios.get(`plans`, { params: { ...filter, _expand: 'exercise' } })
	);
	promises.push(axios.get(`circuits`, { params: filter }));
	promises.push(axios.get(`sequences`, { params: { workoutId: workoutId } }));
	promises.push(axios.get(`workouts/${workoutId}`));
	return new Promise((respond, rej) => {
		Promise.all(promises).then(values => {
			const workoutCats = values[0].data;
			const planData = values[1].data;
			const circuitData = values[2].data;
			const sequenceData = values[3].data;
			const workoutData = {
				...values[4].data,
				info: {
					plans: planData,
					circuits: circuitData,
					sequences: sequenceData,
				},
			};
			dispatch({
				type: FETCH_WORKOUT_CATS,
				payload: workoutCats,
			});
			dispatch({
				type: FETCH_WORKOUT_INFO,
				payload: workoutData,
			});
			dispatch(hideLoader());
			respond(workoutData);
		});
	});
};

export const createWorkout = (type, parentData, childrenData) => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		const postUrl = type === 'block' ? 'blocks' : SERVICE;
		// parentData.name = parentData.name
		// .toLowerCase()
		// .split(' ')
		// .map(s => s.charAt(0).toUpperCase() + s.substring(1))
		// .join(' ');
		axios
			.post(postUrl, parentData)
			.then(res => {
				//make circuits first
				let auxData = _postNewPlans(childrenData, res.data._id, type);
				Promise.all(auxData).then(plans => {
					dispatch(hideLoader());
					dispatch(
						showAlert(
							`${type === 'block' ? 'Block' : 'Workout'} created successfully.`
						)
					);
					response(res);
				});
			})
			.catch(function (err) {
				console.warn(err);
				dispatch(hideLoader());
				if (err.response)
					dispatch(
						showAlert(
							err.response.data.error.message ||
								'Something went wrong. Please try again.',
							true
						)
					);
			});
	});
};

export const updateDuration = (workoutId, type) => dispatch => {
	dispatch(showLoader());
	return new Promise(async (response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		await axios
			.patch(`${SERVICE}/updateDuration/${workoutId}`, {
				type: type,
			})
			.then(res => {
				dispatch(hideLoader());
				response(res);
			})
			.catch(err => {
				dispatch(hideLoader());
				return dispatch(showAlert(err.message));
			});
	});
};

export const patchWorkout = (type, parentData, childrenData) => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		if (!parentData.id) {
			return console.error('Cannot edit item without id.');
		}
		const postUrl = type === 'block' ? 'blocks' : SERVICE;
		parentData.isDeleteRelatedInfomation = true;
		return axios
			.patch(postUrl + `/${parentData.id}`, parentData)
			.then(res => {
				let auxData = _postNewPlans(childrenData, res.data._id, type);
				Promise.all(auxData).then(plans => {
					dispatch(hideLoader());
					dispatch(
						showAlert(
							`${type === 'block' ? 'Block' : 'Workout'} updated successfully.`
						)
					);
					response(res);
				});
			})
			.catch(function (err) {
				dispatch(hideLoader());
				if (err.response)
					dispatch(
						showAlert(
							err.response.data.error.message ||
								'Something went wrong. Please try again.',
							true
						)
					);
			});
	});
};

const EXERCISE_LIMIT = 100;

export const fetchFormValues = (userId, editId) => (dispatch, getState) => {
	let promises = [];
	const state = getState();
	const { equipment, exerciseCats, workoutCats, blockCats, products } = state;
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	promises = checkState(promises, 'categories',  {
		type: 'equipment'
	}, equipment)
	promises = checkState(promises, 'categories', {
		type: 'body-part',
	}, exerciseCats)
	promises.push(
		axios.get('exercises', {
			params: {
				limit: paginationLimit.TEN,
				skip: 0,
				creatorId: userId,
			},
		})
	);
	promises = checkState(promises, 'categories',  {
		type: 'workout'
	}, workoutCats)
	promises = checkState(promises, 'categories',  {
		type: 'block'
	}, blockCats)
	promises = checkState(promises, 'products',  {}, products)
	promises.push(
		axios.get('blocks', {
			params: {
				creatorId: userId,
			},
		})
	);
	
	if (editId) {
		promises.push(dispatch(fetchInfo(editId)));
	}
	return new Promise((respond, rej) => {
		Promise.all(promises).then(values => {
			const equipmentData = values[0].data;
			const corporateCatData = values[1].data;
			const trainerExercises = values[2].data;
			const workoutCats = values[3].data;
			const blockCats = values[4].data;
			const storeProducts = values[5].data;
			const blocksData = values[6].data;
			dispatch({
				type: FETCH_EQUIPMENT,
				payload: equipmentData,
			});
			dispatch({
				type: FETCH_EXERCISE_CATS,
				payload: {
					...corporateCatData,
				},
			});
			dispatch({
				type: FETCH_TRAINER_EXERCISES,
				payload: Object.values(trainerExercises),
			});
			if (Object.values(trainerExercises).length > 0) {
				dispatch({
					type: 	SET_EXERCISES_LOAD_MORE,
					payload: true,
				});
			}
			dispatch({
				type: FETCH_WORKOUT_CATS,
				payload: workoutCats,
			});
			dispatch({
				type: FETCH_BLOCK_CATS,
				payload: blockCats,
			});
			dispatch({
				type: FETCH_STORE_PRODUCTS,
				payload: storeProducts,
			});
			dispatch({
				type: FETCH_BLOCKS,
				payload: blocksData,
			});
			dispatch(hideLoader());
			respond();
		});
	});
};

export const fetchBlockFormValues = (userId, editId) => (dispatch, getState) => {
	let promises = [];
	const state = getState();
	const { equipment, exerciseCats, workoutCats, blockCats, products } = state;
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	promises = checkState(promises, 'categories',  {
		type: 'equipment'
	}, equipment)
	promises = checkState(promises, 'categories', {
		type: 'body-part',
	}, exerciseCats)
	promises.push(
		axios.get('exercises', {
			params: {
				limit: paginationLimit.TEN,
				skip: 0,
				creatorId: userId,
			},
		})
	);
	promises = checkState(promises, 'categories',  {
		type: 'workout'
	}, workoutCats)
	promises = checkState(promises, 'categories',  {
		type: 'block'
	}, blockCats)
	promises = checkState(promises, 'products',  {}, products)
	
	if (editId) {
		promises.push(dispatch(fetchInfo(editId)));
	}
	return new Promise((respond, rej) => {
		Promise.all(promises).then(values => {
			const equipmentData = values[0].data;
			const corporateCatData = values[1].data;
			const trainerExercises = values[2].data;
			const workoutCats = values[3].data;
			const blockCats = values[4].data;
			const storeProducts = values[5].data;
			dispatch({
				type: FETCH_EQUIPMENT,
				payload: equipmentData,
			});
			dispatch({
				type: FETCH_EXERCISE_CATS,
				payload: {
					...corporateCatData,
				},
			});
			dispatch({
				type: FETCH_TRAINER_EXERCISES,
				payload: Object.values(trainerExercises),
			});
			if (Object.values(trainerExercises).length > 0) {
				dispatch({
					type: 	SET_EXERCISES_LOAD_MORE,
					payload: true,
				});
			}
			dispatch({
				type: FETCH_WORKOUT_CATS,
				payload: workoutCats,
			});
			dispatch({
				type: FETCH_BLOCK_CATS,
				payload: blockCats,
			});
			dispatch({
				type: FETCH_STORE_PRODUCTS,
				payload: storeProducts,
			});
			dispatch(hideLoader());
			respond();
		});
	});
};

export const fetchMoreWorkouts = (query) => dispatch => {
	const promises = [];
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	promises.push(
		axios.get('workouts', {
			params: {
				...query,
			},
		})
	);
	if (query.skip === 0) {
		dispatch(showLoader());
	}
	return new Promise((respond, rej) => {
		Promise.all(promises).then(values => {
			const data = values[0].data;
			dispatch(hideLoader());
			dispatch({
				type: FETCH_WORKOUTS,
				payload: data,
			});
		});
	});
};

export const resetWorkouts = () => dispatch => {
	dispatch({
		type: RESET_WORKOUTS,
	});
};

export const resetWorkoutInfo = () => dispatch => {
	dispatch({
		type: RESET_WORKOUT_INFO,
	});
};

export const updateOrder  = (reqOrder, items) => dispatch => {
	dispatch(showLoader());
	dispatch({
		type: UPDATE_ORDER_WORKOUTS,
		payload: reqOrder,
	});
	return new Promise(async (response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.patch(`${SERVICE}/update/byOrders`, { orders: items })
			.then(res => {
				dispatch(hideLoader());
			})
			.catch(err => {
				dispatch(hideLoader());
				return dispatch(showAlert(err.message));
			});
	});
};

export const fetchList = query => dispatch => {
	const promises = [];
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	promises.push(axios.get('categories', { params: { type: 'workout' } }));
	promises.push(
		axios.get(`workouts`, {
			params: query,
		})
	);
	return new Promise((respond, rej) => {
		Promise.all(promises).then(values => {
			const workoutCats = values[0].data;
			const trainerWorkouts = values[1].data;
			dispatch({
				type: FETCH_WORKOUT_CATS,
				payload: workoutCats,
			});
			dispatch({
				type: FETCH_WORKOUTS,
				payload: trainerWorkouts,
			});
			dispatch(hideLoader());
			respond();
		});
	});
};

export const updateWorkoutImg = (workoutId, url) => dispatch => {
	dispatch(showLoader());
	return new Promise(async (response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.patch(`${SERVICE}/updateExcerciseImgUrl/${workoutId}`, { url })
			.then(res => {
				dispatch(hideLoader());
				response(res);
			})
			.catch(err => {
				dispatch(hideLoader());
				return dispatch(showAlert(err.message));
			});
	});
};

export const duplicateWorkout = workoutId => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.post(`${SERVICE}/duplicate/${workoutId}`, {})
			.then(res => {
				dispatch(hideLoader());
				dispatch(showAlert(res.data.message));
				response(res.data);
			})
			.catch(err => {
				dispatch(hideLoader());
				if (err.response) {
					dispatch(addError(err.response.data.error.message));
				}
				reject();
			});
	});
};

export const archiveWorkout = (data) => dispatch => {
	console.log(data);
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.post(`${SERVICE}/archive/${data._id}`, {status: data.status})
			.then(res => {
				dispatch(hideLoader());
				dispatch(showAlert(res.data.message));
				response(res.data);
			})
			.catch(err => {
				dispatch(hideLoader());
				if (err.response) {
					dispatch(addError(err.response.data.error.message));
				}
				reject();
			});
	});
};




// WEBPACK FOOTER //
// ./src/store/actions/workouts.js